<template>
  <MainTemplate>
    <MainNavbar
      slot="header"
      has-small-logo
      :has-menu="false"
    />
    <MainFooter slot="footer" />
    <transition
      name="fade"
      mode="out-in"
      :duration="{ enter: 1000, leave: 200 }"
    >
      <BaseLoading
        v-if="isMatchLoading"
        full-screen
      />
      <div
        v-else
        class="w-100"
      >
        <b-row>
          <b-col
            :cols="12"
            :class="[
              $style.withBottomBorder
            ]"
          >
            <b-container>
              <TheRoundTitle
                :image="match.round.season.league.image_url"
                :league-name="match.round.season.league.name[$i18n.locale]"
                :round-name="match.round.name[$i18n.locale]"
              />
            </b-container>
          </b-col>

          <b-col
            :cols="12"
            :class="[
              $style.withBottomBorder
            ]"
          >
            <b-container>
              <TheMatchHeader
                :start-date="match.start"
                :status="match.status"
                :team1="match.team1"
                :team2="match.team2"
                :score-team1="match.score_team1"
                :score-team2="match.score_team2"
              />
            </b-container>
          </b-col>

          <b-col
            :cols="12"
            :class="[
              'd-flex justify-content-center py-3',
              $style.withBottomBorder
            ]"
          >
            <router-link
              :to="{ name: 'match' }"
              class="mr-1"
            >
              <BaseButton
                :variant="$router.currentRoute.name === 'match' ? 'orange' : 'outline-orange'"
                font-size="small"
                left-rounded
              >
                <span class="px-2">{{ $t('goals') }}</span>
              </BaseButton>
            </router-link>

            <router-link :to="{ name: 'match-public-highlights' }">
              <BaseButton
                :variant="$router.currentRoute.name === 'match-public-highlights' ? 'orange' : 'outline-orange'"
                font-size="small"
                right-rounded
              >
                <span class="px-2">{{ $t('highlights') }}</span>
              </BaseButton>
            </router-link>
          </b-col>
          <b-col :cols="12">
            <router-view />
          </b-col>
        </b-row>
      </div>
    </transition>
  </MainTemplate>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MainTemplate from '@/layout/Templates/MainTemplate'
import MainNavbar from '@/layout/MainNavbar'
import MainFooter from '@/layout/MainFooter'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseLoading from '@/components/Atoms/BaseLoading'
import TheMatchHeader from '@/components/Molecules/TheMatchHeader'
import TheRoundTitle from '@/components/Molecules/TheRoundTitle'

export default {
  name: 'Match',
  components: {
    BaseButton,
    TheRoundTitle,
    TheMatchHeader,
    MainFooter,
    MainNavbar,
    MainTemplate,
    BaseLoading,
  },
  metaInfo() {
    if (this.match) {
      return {
        title: this.$t('page-titles.match-detail', {
          team1: this.match.team1 ? this.match.team1.name[this.$i18n.locale] : '',
          team2: this.match.team2 ? this.match.team2.name[this.$i18n.locale] : '',
        }),
      }
    }
  },
  data() {
    return {
      matchId: `${this.$route.params.league}/${this.$route.params.match}`,
    }
  },
  computed: {
    ...mapState({
      isMatchLoading: state => state['matches/match'].isMatchLoading,
    }),
    match() {
      return this.$store.getters['matches/match/getMatch'](this.matchId)
    },
  },
  created() {
    this.fetchMatch({
      matchId: this.matchId,
    })
  },
  methods: {
    ...mapActions({
      fetchMatch: 'matches/match/fetchMatch',
    }),
  },
}
</script>

<style module lang="scss">
  @import '../../../assets/scss/variables';
  .withBottomBorder {
    border-bottom: 4px solid $color-bleached-silk;
  }
</style>
